import GalleryModal from './GalleryModal';

export default GalleryModal;
